export default __webpack_public_path__ + "static/media/Robusta-2.66dccfe2.jpg";